import { memo } from 'react';
import { useSelector } from 'react-redux';

import { ContentCollectionView, contentCollectionViewSelector } from '@air/feature-content-collection/redux';

import { ContentCollectionAutoSubmitView } from '~/components/ContentCollection/ContentCollectionAutoSubmitView';
import { ContentCollectionCompletedView } from '~/components/ContentCollection/ContentCollectionFormCompletedView';
import { ContentCollectionManageView } from '~/components/ContentCollection/ContentCollectionManageView';
import { ContentCollectionOnboardingView } from '~/components/ContentCollection/ContentCollectionOnboardingView';

export type ContentCollectionViewManagerProps = {
  requireAccount: boolean;
};

export const ContentCollectionViewManager = memo(({ requireAccount }: ContentCollectionViewManagerProps) => {
  const view = useSelector(contentCollectionViewSelector);

  switch (view) {
    case ContentCollectionView.Onboarding:
      return <ContentCollectionOnboardingView requireAccount={requireAccount} />;
    case ContentCollectionView.Manage:
      return <ContentCollectionManageView />;
    case ContentCollectionView.Completed:
      return <ContentCollectionCompletedView />;
    case ContentCollectionView.AutoSubmit:
      return <ContentCollectionAutoSubmitView />;
    default:
      return null;
  }
});

ContentCollectionViewManager.displayName = 'ContentCollectionViewManager';
